import { graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";

import { blockedCountries } from "../../utils/sharedDatasets";
import CalendlyBridgeStep from "./applicationFormSteps/CalendlyBridgeStep";
import Step1 from "./applicationFormSteps/Step1";
import Step2 from "./applicationFormSteps/Step2";
import Step3 from "./applicationFormSteps/Step3";
import Step4 from "./applicationFormSteps/Step4";
import StepNav from "./applicationFormSteps/StepNav";

const ApplicationForm = ({ formStep, details = {}, theme }) => {
  const { stdPrograms } = useStaticQuery(graphql`
    query {
      stdPrograms: allWpProgram {
        nodes {
          id
          title
          databaseId
          acfProgramsMeta {
            programCode
            programPopular
            programCapacity
            programTypes {
              ... on WpProgramType {
                id
                title
                slug
              }
            }
          }
        }
      }
    }
  `);

  const combinedPrograms = stdPrograms?.nodes?.map((prog) => prog);

  const [currentStep, setCurrentStep] = useState(parseInt(formStep));

  const [isFlexProgram, setIsFlexProgram] = useState(false);
  const [isGrantsAvailable, setIsGrantsAvailable] = useState(true);
  const [tabHeading, setTabHeadings] = useState([]);

  useEffect(() => {
    const currentUrl = new URL(window.location);

    if (
      /virtual_program|online_program|virtual_career|virtual_uncc|online_program/.test(
        currentUrl?.search
      ) ||
      /gvivirtual|gvionline/.test(details?.referring_form_type)
    ) {
      setIsGrantsAvailable(false);
    }

    if (details?.flex_program || /flex_program/.test(currentUrl?.search)) {
      setIsFlexProgram(true);
    }
  }, []);

  const showPricingExtra = true;

  const defaultStep2Details = [
    {
      title: "80% grants available",
      detail: "Based on circumstances and motivation.",
      ico_star: true
    },
    {
      title: "Book with confidence",
      detail:
        "Modify your booking, even up to 48 hours before departure. <a  class='underline' href='/terms-and-conditions' rel='nofollow' target='_gviblank'>T&Cs apply.</a>",
      ico_shield: true
    },
    {
      title: "Payment plans",
      detail: "Chat to us about our flexible payment plan options.",
      ico_card: true
    }
  ].filter(Boolean);

  const ingoStepNavDetails = [
    {
      title: "Book with confidence",
      detail:
        "Modify your booking, even up to 48 hours before departure. <a  class='underline' href='/terms-and-conditions' rel='nofollow' target='_gviblank'>T&Cs apply.</a>",
      ico_shield: true
    },
    {
      title: "Payment plans",
      detail: "Chat to us about our flexible payment plan options.",
      ico_card: true
    }
  ];

  const [checkCountries, setBlockedCountries] = useState(false);

  useEffect(() => {
    const analytics = JSON.parse(
      window?.localStorage.getItem("gvx-analytics") || "{}"
    );
    const country = analytics?.country;
    const isBlockedcountry = blockedCountries.includes(country);

    setBlockedCountries(isBlockedcountry);
  }, []);

  useEffect(() => {
    setTabHeadings([
      ...(isGrantsAvailable ? defaultStep2Details : ingoStepNavDetails)
    ]);
  }, [isGrantsAvailable]);

  const isEnquiry = details["submission_type"] === "enquiry";

  return (
    <section
      className={`relative flex flex-col items-center justify-center mx-auto md:px-0 application-form-section ${
        currentStep === 2 ? "sm:pt-20 sm:pb-0" : " sm:py-20 "
      }`}
    >
      <div className="flex flex-col-reverse w-full md:flex-col md:w-2/3">
        {checkCountries ? (
          <div className="form-tab-content p-10 font-body text-white text-xl text-center">
            Sorry, this form is not available in your country.
          </div>
        ) : (
          <>
            {(currentStep === 0 || currentStep === 1 || currentStep === 8) &&
            !isEnquiry ? (
              <StepNav
                tabHeading={tabHeading}
                currentStep={currentStep}
                showPriceIcon={showPricingExtra}
              />
            ) : (
              <></>
            )}

            <div
              className={`form-tab-content ${
                currentStep === 2 ? "sm:rounded-b-none" : ""
              }`}
            >
              {currentStep === 0 ? (
                <Step1
                  goToNext={() => setCurrentStep(1)}
                  programs={combinedPrograms}
                  isFlexProgram={isFlexProgram}
                  extraDetails={details}
                  setIsGrantsAvailable={setIsGrantsAvailable}
                />
              ) : currentStep === 1 ? (
                <Step2
                  goToNext={() => setCurrentStep(2)}
                  programs={combinedPrograms}
                  extraDetails={details}
                />
              ) : currentStep === 2 ? (
                <Step3 extraDetails={details} />
              ) : currentStep === 3 ? (
                <Step4 programs={combinedPrograms} extraDetails={details} />
              ) : currentStep === 8 ? (
                <CalendlyBridgeStep
                  programs={combinedPrograms}
                  extraDetails={details}
                />
              ) : null}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ApplicationForm;
